module.exports = __webpack_public_path__ + "static/media/A1_Bulgaria.a8991b6e.png";